import * as React from 'react';

import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';
import { ErrorBoundaryWithLocation } from '@common/react/components/UI/ErrorBoundary/ErrorBoundary';
import Application from '@common/react/components/Core/Application/Application';
import GoogleKeysProvider from '@common/react/components/google/GoogleKeysProvider/GoogleKeysProvider';
import GoogleTagManager from '@common/react/components/google/GoogleTagManager/GoogleTagManager';
import BaseModalContextProvider from '@common/react/components/base/BaseModalContextProvider/BaseModalContextProvider';

import ReduxProvider from '@app/hooks/useReduxContext';

import '@app/scss/style.scss';

const Layout: React.FC = ({ children }) => <div className="app-container">
	<ErrorBoundaryWithLocation>
		<ReduxProvider>
			{({ companySettings: { googleAnalyticsId, googleTagManagerId }, location }) =>
				<GoogleKeysProvider
					analyticsId={googleAnalyticsId || ''}
					tagManagerId={googleTagManagerId || ''}
					mapKey={location?.company?.googleApiKey || ''}
				>
					<GoogleTagManager />
					<RequestProvider>
						<Application
							withoutSignalR
						>
							<BaseModalContextProvider>
								<div className="content">{children}</div>
							</BaseModalContextProvider>
						</Application>
					</RequestProvider>
				</GoogleKeysProvider>
			}
		</ReduxProvider>
	</ErrorBoundaryWithLocation>
</div>;

export default Layout;
